var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"watermarks-footer"},[_c('li',{staticClass:"watermarks-footer__item watermarks-footer__ssl"}),_vm._v(" "),_c('li',{staticClass:"watermarks-footer__item watermarks-footer__dmca"}),_vm._v(" "),(_vm.shouldShowNSPA)?_c('li',{staticClass:"watermarks-footer__item watermarks-footer__nspa"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }